var documentClick = true;
$(document).ready(function () {
    $(document).on('touchstart', function () {
        documentClick = true;
    });
    $(document).on('touchmove', function () {
        documentClick = false;
    });

    $('#searchButton').on('click', function () {
        var query = $('#searchInput').val();
        if (query) {
            window.location.href = '/search/init?q=' + encodeURIComponent(query);
        }
    });

    $('#waw-navbar').on('show.bs.collapse', function () {
        $('body').addClass('mobile-nav-active');
    });

    $('#waw-navbar').on('hidden.bs.collapse', function () {
        $('body').removeClass('mobile-nav-active');
    });

    $("#header .topbar").addClass("topbar-transition");
    $('#banner-notification').height($("#banner-notification").height());
});

$(document).on('mouseenter', '.nav-item .dropdown-btn', function (e) {
    setSubMenuPosition(this);
});

$(document).on('touchend', '.nav-item .dropdown-btn', function (e) {
    if (documentClick) {
        e.preventDefault();
        setSubMenuPosition(this);
        toggleMenuDropdown(this);
        e.stopImmediatePropagation();
    }
});

$(document).on('click', '.mobile-nav-active .nav-item .dropdown-btn', function (e) {
    e.preventDefault();
    toggleMenuDropdown(this);
    e.stopImmediatePropagation();
});

function setSubMenuPosition(arg) {
    const $dropdown = $(arg).parent(".dropdown");
    const $subMenu = $dropdown.find('ul');

    const rect = $dropdown[0].getBoundingClientRect();
    const viewportWidth = $(window).width();
    const viewportHeight = $(window).height();

    let positionClass = '';

    const spaceTop = rect.top;
    const spaceBottom = viewportHeight - rect.bottom;
    const spaceLeft = rect.left;
    const spaceRight = viewportWidth - rect.right;

    // Priority to right side
    if (spaceRight >= $subMenu.outerWidth()) {
        // If there's enough space on the right
        if (spaceBottom >= $subMenu.outerHeight()) {
            positionClass = 'bottom-right';
        } else if (spaceTop >= $subMenu.outerHeight()) {
            positionClass = 'top-right';
        } else {
            positionClass = 'bottom-right'; // Default to bottom if top/bottom doesn't fit
        }
    } else {
        // Fallback to left if not enough space on the right
        if (spaceLeft >= $subMenu.outerWidth()) {
            if (spaceBottom >= $subMenu.outerHeight()) {
                positionClass = 'bottom-left';
            } else if (spaceTop >= $subMenu.outerHeight()) {
                positionClass = 'top-left';
            } else {
                positionClass = 'bottom-left'; // Default to bottom if top/bottom doesn't fit
            }
        } else {
            // If there’s no room on either side, default to bottom-right (fallback)
            positionClass = 'bottom-right';
        }
    }

    // Remove existing position classes and add the new one
    $subMenu.removeClass('top-left top-right bottom-left bottom-right');
    $subMenu.addClass(positionClass);
};

function toggleMenuDropdown(element) {
    var activeSibling = $(element).parent().siblings(".dropdown.active")
    if (activeSibling?.length) {
        activeSibling.removeClass('active');
        activeSibling.find(".dropdown").removeClass('active');
        activeSibling.find("ul").removeClass('dropdown-active')
    }

    if ($(element).parent().hasClass("active")) {
        var childActiveMenu = $(element).siblings(".dropdown-active");
        childActiveMenu.find(".dropdown").removeClass('active');
        childActiveMenu.find("ul").removeClass('dropdown-active')
    }

    $(element).parent().toggleClass('active');
    $(element).next().toggleClass('dropdown-active');
}

function toggleScrolled() {
    const selectBody = document.querySelector('body');
    var isScrolled = $(selectBody).hasClass("scrolled");
    if ((window.scrollY > $("#header").height() && !isScrolled) || (window.scrollY >= 70 && isScrolled)) {
        selectBody.classList.add('scrolled')

    } else {
        selectBody.classList.remove('scrolled');
    }
}

document.addEventListener('scroll', toggleScrolled);
window.addEventListener('load', toggleScrolled);

/**
 * Hide mobile nav on same-page/hash links
 */
$(document).on('click', '#waw-navbar .nav-item a:not(.dropdown-btn)', function () {
    if ($('.mobile-nav-active').length) {
        $('#navbar-toggler').trigger('click');
    }
});

$(document).on('click', function (event) {
    var $target = $(event.target);
    if (!$target.closest('#waw-navbar').length) {
        $('.nav-item .dropdown-btn').next().removeClass('dropdown-active');
        $('.nav-item.dropdown').removeClass('active');
    }
});